module.exports = __webpack_public_path__ + "img/Mercantil45.dfff552a.png";